// Professional work experience and educational journey data
// Arranged chronologically from earliest (2021) to most recent
export const experience = [
  {
    id: 6,
    title: "STEM Robotics Instructor",
    company: "Freelance / School Outreach",
    duration: "2026 - Present",
    location: "Accra, Ghana",
    type: "Freelance",
    status: "in progress",
    description:
      "Teaching fundamental STEM and robotics concepts to students across primary and junior high schools in Accra. Visited 3+ international schools this year, introducing hands-on robotics, coding, and technology education to young learners.",
    responsibilities: [
      "Design and deliver engaging STEM robotics lessons for school students",
      "Introduce robotics programming concepts using beginner-friendly platforms",
      "Conduct hands-on workshops at 3+ international schools in Accra, Ghana",
      "Inspire the next generation of tech innovators through practical demonstrations",
      "Adapt curriculum to different age groups and learning levels",
    ],
    technologies: [
      "Robotics",
      "STEM Education",
      "Programming Fundamentals",
      "Hands-on Learning",
    ],
    achievements: [
      "Delivered robotics workshops at 3+ international schools in Accra",
      "Introduced STEM concepts to hundreds of students across Ghana",
    ],
  },
  {
    id: 1,
    title: "Computer Science Graduate",
    company: "All Nations University (ANU)",
    duration: "Sep 2021 - Nov 15, 2025",
    location: "Koforidua, Ghana",
    type: "Education",
    description:
      "Pursued Bachelor's degree in Computer Science, gaining comprehensive knowledge in software development, algorithms, data structures, and modern computing technologies. Graduated on November 15, 2025, with the distinguished achievement of serving as President for two departments during my academic tenure.",
    responsibilities: [
      "Completed rigorous coursework in algorithms, data structures, software engineering, and database systems",
      "Served as President for two different departments at All Nations University",
      "Contributed to establishing and promoting the ANU Football League, increasing its visibility and media presence",
      "Served as platform moderator for the ANU Football League management system",
      "Led student initiatives and represented departments in university activities",
      "Developed multiple academic and personal projects using modern technologies",
      "Completed Class B driving licence at All Nations Driving School (ANU campus)",
    ],
    technologies: [
      "Python",
      "Java",
      "C++",
      "Data Structures",
      "Algorithms",
      "Software Engineering",
      "Database Systems",
    ],
    achievements: [
      "Graduated with B.Sc. in Computer Science (Nov 15, 2025)",
      "Served as President for two departments at All Nations University",
      "Contributed to establishing ANU Football League and making it known in media",
      "Platform moderator for ANU Football League management system",
      "Earned Class B driving licence at All Nations Driving School",
    ],
  },
  {
    id: 2,
    title: "Content Creator & Creative Director",
    company: "Freelance / Various Clients",
    duration: "Jan 2022 - Present",
    location: "Remote",
    type: "Freelance",
    status: "in progress",
    description:
      "Creating compelling multimedia content and directing creative campaigns for brands and businesses. Developing social media strategies, producing video content, and managing digital brand presence across platforms.",
    responsibilities: [
      "Develop and execute creative content strategies for diverse client base",
      "Produce high-quality video, graphics, and multimedia content",
      "Manage social media accounts and grow audience engagement",
      "Direct creative campaigns from concept to execution",
      "Analyze content performance and optimize strategies for maximum impact",
      "Stay current with trends in content creation and digital marketing",
    ],
    technologies: [
      "Adobe Premiere Pro",
      "Final Cut Pro",
      "Social Media Analytics",
      "SEO",
    ],
    achievements: [
      "Grew client social media followings by average of 150%",
      "Created viral content with 500K+ reach",
    ],
  },
  {
    id: 2.5,
    title: "Prompt Engineering & AI Integration",
    company: "Self-Learning / Professional Development",
    duration: "Early 2023",
    location: "Remote",
    type: "Professional Development",
    description:
      "Learned and mastered prompt engineering techniques for AI models, focusing on optimizing interactions with large language models like ChatGPT and Claude. Applied these skills to enhance development workflows and client projects.",
    responsibilities: [
      "Studied prompt engineering techniques and best practices",
      "Experimented with various AI models and tools (ChatGPT, Claude)",
      "Integrated AI capabilities into development workflows",
      "Applied prompt engineering to solve real-world development challenges",
      "Optimized AI interactions for code generation and problem-solving",
      "Developed efficient prompting strategies for different use cases",
    ],
    technologies: [
      "ChatGPT",
      "Claude AI",
      "Prompt Engineering",
      "AI-Assisted Development",
      "Large Language Models",
    ],
    achievements: [
      "Mastered prompt engineering fundamentals",
      "Successfully integrated AI tools into daily workflow",
      "Improved development productivity through AI assistance",
    ],
  },
  {
    id: 3,
    title: "CEO & Lead Software Engineer",
    company: "Tboye Creative Solutions",
    duration: "Jan 2023 - Present",
    location: "Ghana",
    type: "Full-time",
    status: "in progress",
    description:
      "Founded and leading a creative technology company that delivers innovative software solutions, web development, and creative content services. Managing end-to-end project delivery while actively developing cutting-edge applications.",
    responsibilities: [
      "Lead strategic planning and business development initiatives",
      "Architect and develop full-stack web applications using React, Node.js, and modern frameworks",
      "Manage project delivery for clients across creative and technical domains",
      "Design and implement scalable software solutions with focus on user experience",
      "Build and maintain client relationships while ensuring project excellence",
      "Create engaging content and direct creative campaigns across digital platforms",
    ],
    technologies: [
      "React",
      "Node.js",
      "Python",
      "PostgreSQL",
      "AWS",
      "Tailwind CSS",
      "Next.js",
    ],
    achievements: [
      "Successfully delivered 25+ client projects",
      "Grew company from solo operation to sustainable business",
    ],
  },
  {
    id: 5,
    title: "Freelance Penetration Tester & Security Consultant",
    company: "Freelance / Various Clients",
    duration: "Jan 2026 - Present",
    location: "Remote",
    type: "Freelance",
    status: "in progress",
    description:
      "Conducting authorized penetration tests and security assessments for businesses and individuals. Identifying vulnerabilities in web applications, networks, and systems, then providing clear remediation guidance to help clients fix issues and strengthen their overall security posture.",
    responsibilities: [
      "Perform web application penetration testing following OWASP methodologies",
      "Conduct network security assessments and vulnerability scanning",
      "Identify and safely exploit vulnerabilities in authorized, controlled environments",
      "Write detailed security assessment reports with severity ratings and step-by-step remediation",
      "Work directly with clients to prioritize and fix discovered vulnerabilities",
      "Provide security hardening recommendations and best practices",
      "Perform reconnaissance and OSINT gathering for comprehensive threat analysis",
      "Stay updated with latest CVEs, exploits, and emerging security research",
    ],
    technologies: [
      "Burp Suite",
      "Nmap",
      "Metasploit",
      "OWASP ZAP",
      "Wireshark",
      "Kali Linux",
      "Python",
      "OSINT Tools",
    ],
    achievements: [
      "Discovered and responsibly disclosed critical vulnerabilities in multiple client systems",
      "Helped clients significantly reduce their attack surface and improve security posture",
      "Built reputation for thorough, accurate, and actionable security reports",
    ],
  },
  {
    id: 4,
    title: "Software Development Intern",
    company: "Go2Cod",
    duration: "Oct 2024 - Present",
    location: "Remote",
    type: "Internship",
    description:
      "Gaining hands-on experience in professional software development workflows. Working on real-world projects with guidance from senior developers, focusing on full-stack development and modern best practices.",
    responsibilities: [
      "Develop and deliver assigned projects from planning through deployment",
      "Collaborate with senior developers for code reviews and mentorship",
      "Implement both frontend and backend features using modern technology stacks",
      "Write clean, maintainable code following industry best practices",
      "Test, debug, and optimize applications for performance and scalability",
      "Participate in agile development processes and team standups",
    ],
    technologies: ["JavaScript", "React", "Node.js", "Git", "Agile/Scrum"],
    achievements: ["Successfully completed assigned project ahead of schedule"],
  },
];
